import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { authClient } from '../lib/auth-client'
import { Icon } from '../components/Common.jsx'
import AuthSide from '../components/AuthSide.jsx'

export default function ForgotPasswordPage() {
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [sent, setSent] = useState(false)
  const [error, setError] = useState('')

  const submit = async (e) => {
    e.preventDefault()
    setError('')
    setSubmitting(true)

    try {
      const requestReset =
        authClient.requestPasswordReset || authClient.forgetPassword
      const { error: authError } = await requestReset({
        email: email.trim(),
        redirectTo: `${window.location.origin}/reset-password`,
      })
      if (authError) {
        setSubmitting(false)
        setError(authError.message || 'Could not send reset link. Try again.')
        return
      }
      setSubmitting(false)
      setSent(true)
      setTimeout(() => navigate('/signin'), 1500)
    } catch (err) {
      setSubmitting(false)
      setError('Could not send reset link. Try again.')
    }
  }

  return (
    <div className="auth-page">
      <AuthSide
        title="Reset your password."
        subtitle="We'll send a one-time link at your registered email so you can set a new password."
        stats={[{ v: '1 click', l: 'Reset' }, { v: 'Secure', l: 'Always' }, { v: '24/7', l: 'Support' }]}
        chatVariant="A"
      />
      <div className="auth-form-wrap">
        <form className="auth-form" onSubmit={submit}>
          <h1>Forgot password?</h1>
          <p>Enter your email and we'll send a reset link</p>

          {error && (
            <div
              role="alert"
              style={{
                marginBottom: 16, padding: '10px 14px', borderRadius: 10, fontSize: 13,
                background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.4)', color: '#F87171',
              }}
            >
              {error}
            </div>
          )}

          {sent && (
            <div
              role="status"
              style={{
                marginBottom: 16, padding: '10px 14px', borderRadius: 10, fontSize: 13,
                background: 'rgba(16,185,129,0.1)', border: '1px solid rgba(16,185,129,0.4)', color: '#10B981',
              }}
            >
              Reset link sent. Check your email.
            </div>
          )}

          <div className="field">
            <label>Email address</label>
            <div className="input-group">
              <Icon name="mail" size={16} />
              <input
                type="email"
                className="input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="you@company.com"
                autoComplete="email"
              />
            </div>
          </div>

          <button
            className="btn btn-primary"
            type="submit"
            disabled={submitting || sent}
            style={{ width: '100%', justifyContent: 'center' }}
          >
            {submitting ? 'Sending...' : <>Send reset link <Icon name="send" size={16} /></>}
          </button>

          <div className="auth-foot">
            <Link to="/signin">
              <Icon name="arrow-left" size={13} style={{ display: 'inline', verticalAlign: -2 }} /> Back to sign in
            </Link>
          </div>
        </form>
      </div>
    </div>
  )
}
